import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconUnlocked: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconUnlocked"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C9.23858 2 7 4.23858 7 7V9H4V22H20V9H9V7C9 5.34315 10.3431 4 12 4C13.6569 4 15 5.34315 15 7H17C17 4.23858 14.7614 2 12 2ZM13 13V18H11V13H13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconUnlocked;
